export default {
  fromValue (val) {
    switch (val) {
      case 'new':
        return 'Nova'
      case 'confirmed':
        return 'Confirmada'
      default:
        return val
    }
  }
}
